export var BusinessReferralStatus;
(function (BusinessReferralStatus) {
    BusinessReferralStatus["Attributed"] = "ATTRIBUTED";
    BusinessReferralStatus["Activated"] = "ACTIVATED";
    BusinessReferralStatus["Expired"] = "EXPIRED";
    BusinessReferralStatus["Completed"] = "COMPLETED";
    BusinessReferralStatus["Disqualified"] = "DISQUALIFIED";
})(BusinessReferralStatus || (BusinessReferralStatus = {}));
//# sourceMappingURL=BusinessReferralStatus.js.map